import React, { useState, useContext } from "react";

const tabIndexContext = React.createContext();

const useTabIndex = () => useContext(tabIndexContext);

const TabIndexProvider = ({ children }) => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <tabIndexContext.Provider value={{ tabIndex, setTabIndex }}>
      {children}
    </tabIndexContext.Provider>
  );
};

export { useTabIndex, TabIndexProvider };
